/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  KnowledgeToken,
  KnowledgeTokenInterface,
} from "../../contracts/KnowledgeToken";

const _abi = [
  {
    inputs: [],
    name: "Initialized",
    type: "error",
  },
  {
    inputs: [],
    name: "NeedMoreETHSent",
    type: "error",
  },
  {
    inputs: [],
    name: "NonTransferrable",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenDoesNotExist",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "publicationId",
        type: "uint256",
      },
    ],
    name: "KnowledgeTokenMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "WRITER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "_burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWithdrawableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "publication",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "publicationId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mintTimestampOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "s_adminFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "s_tokenCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "s_tokenToPublication",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "s_tokenUri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "s_writerFeesAccrued",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "s_writerFeesWithdrawn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "adminFee",
        type: "uint16",
      },
    ],
    name: "setAdminFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenDataOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint96",
            name: "mintTimestamp",
            type: "uint96",
          },
        ],
        internalType: "struct IERC721Time.TokenData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type KnowledgeTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: KnowledgeTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class KnowledgeToken__factory extends ContractFactory {
  constructor(...args: KnowledgeTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<KnowledgeToken> {
    return super.deploy(overrides || {}) as Promise<KnowledgeToken>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): KnowledgeToken {
    return super.attach(address) as KnowledgeToken;
  }
  override connect(signer: Signer): KnowledgeToken__factory {
    return super.connect(signer) as KnowledgeToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): KnowledgeTokenInterface {
    return new utils.Interface(_abi) as KnowledgeTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): KnowledgeToken {
    return new Contract(address, _abi, signerOrProvider) as KnowledgeToken;
  }
}
